import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

interface AutoScrollToTopProps {
  children: React.ReactNode;
}

export const AutoScrollToTop: FC<AutoScrollToTopProps> = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    const ua = navigator.userAgent.toLowerCase();
    if (/qq/.test(ua) && /qqtheme/.test(ua)) {
      window.scrollTo(0, 1);
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname]);
  return <>{children}</>;
};
